// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3mLbb","inputWrap":"styles_inputWrap__3Uq63","input":"styles_input__3TCO-"};